import React from 'react';
import { Table } from 'antd';
import { usePendingOutbound } from '../../hooks/useStudioOps';

export default function AuditedOutbound() {
    const { data, isFetching } = usePendingOutbound({ pageNum: 1, pageSize: 50, pivot: 'destination' });
    return (
        <div style={{ padding: 16 }}>
            <Table
                loading={isFetching}
                rowKey={r => `${r.companyCode}-${r.destination}`}
                dataSource={data?.data?.pivot || []}
                columns={[
                    { title: 'Client', dataIndex: 'companyCode' },
                    { title: 'Destination', dataIndex: 'destination' },
                    { title: 'Boxes', dataIndex: 'boxes' },
                    { title: 'Items', dataIndex: 'items' },
                ]}
            />
        </div>
    );
}
